export interface PermanentSaveSummary {
  id: number;
  reviewStatus: 'PENDING' | 'APPROVED' | 'REJECTED' | 'CANCELLED';
  executionStatus: 'NOT_STARTED' | 'PROCESSING' | 'SUCCESS' | 'FAILED';
  reviewReason?: string;
}

export interface PermanentSaveRequest extends PermanentSaveSummary {
  reason: string;
  executionError?: string;
  fileName: string;
  url: string;
  savedAt?: string;
}

export interface PermanentSaveQuota {
  used: number;
  limit: number;
  remaining: number;
  baseLimit: number;
  activeVip: boolean;
  vipLevel?: string;
  vipBonus: number;
  vipBonuses: Record<string, number>;
}

export const canApplyForPermanentSave = (loggedIn: boolean, storageType?: string): boolean =>
  loggedIn && (storageType === 'TEMPORARY' || storageType === 'NORMAL');

export const permanentSaveStatusKey = (request?: PermanentSaveSummary): string => {
  if (!request) return 'permanentSave.apply';
  if (request.reviewStatus === 'APPROVED') {
    return `permanentSave.status.${request.executionStatus}`;
  }
  return `permanentSave.status.${request.reviewStatus}`;
};

async function request<T>(path: string, body?: unknown): Promise<T> {
  const response = await fetch(`/img/permanent-save-requests${path}`, {
    method: body === undefined ? 'GET' : 'POST',
    credentials: 'same-origin', cache: 'no-store',
    headers: { 'Content-Type': 'application/json' },
    body: body === undefined ? undefined : JSON.stringify(body),
  });
  const result = await response.json();
  if (!response.ok || !result.success) throw new Error(result.message || 'permanentSave.requestFailed');
  return result.data as T;
}

export const submitPermanentSave = (uploadRecordId: number, uid: string, reason: string) =>
  request<PermanentSaveRequest>('', { uploadRecordId, uid, reason });

export const getPermanentSave = (id: number) => request<PermanentSaveRequest>(`/${id}`);

export const getPermanentSaveQuota = () => request<PermanentSaveQuota>('/quota');
